import React, { useMemo } from 'react';
import FeaturesContext, { Features } from 'context/FeaturesContext';
import { useLocalStorage } from 'services/hooks';
import { FeaturesProviderProps } from './FeaturesProvider.props';

export const FeaturesProvider = ({ children }: FeaturesProviderProps) => {
  const [features] = useLocalStorage<Features>('features', {});
  const contextValue = useMemo(() => ({ features: features ?? {} }), [features]);

  return <FeaturesContext.Provider value={contextValue}>{children}</FeaturesContext.Provider>;
};
